import { Select } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { ScenePreset } from 'types';
import { getScenePresetDisplayName } from 'utils/embed/layout';
import { useIsInteractionDisabled, useSelectPreset } from '../state';

export type EditScenePresetSelectorProps = {};

const EditScenePresetSelector: React.FC<EditScenePresetSelectorProps> = () => {
  const { selectPreset, selectedPreset } = useSelectPreset();
  const { isInteractionDisabled } = useIsInteractionDisabled();

  const handleSelectionChange = useCallback(
    (key: React.Key) => {
      selectPreset(Number(key) as ScenePreset);
    },
    [selectPreset],
  );

  return (
    <Select
      isDisabled={isInteractionDisabled}
      label="Scene Preset"
      fluid
      onSelectionChange={handleSelectionChange}
      selectedKey={selectedPreset.toString()}
    >
      <Select.Option key={ScenePreset.CURRENT}>
        {getScenePresetDisplayName(ScenePreset.CURRENT)}
      </Select.Option>
      <Select.Option key={ScenePreset.FIT}>
        {getScenePresetDisplayName(ScenePreset.FIT)}
      </Select.Option>
      <Select.Option key={ScenePreset.FULL_SCREEN}>
        {getScenePresetDisplayName(ScenePreset.FULL_SCREEN)}
      </Select.Option>
      <Select.Option key={ScenePreset.SPLIT}>
        {getScenePresetDisplayName(ScenePreset.SPLIT)}
      </Select.Option>
      <Select.Option key={ScenePreset.THREE}>
        {getScenePresetDisplayName(ScenePreset.THREE)}
      </Select.Option>
      <Select.Option key={ScenePreset.FOUR}>
        {getScenePresetDisplayName(ScenePreset.FOUR)}
      </Select.Option>
    </Select>
  );
};

export default EditScenePresetSelector;
